import { BATCH_MESSAGE, BufferedPort } from "./types";

export const createBufferedPort: () => BufferedPort = () => {
  let messagePort: MessagePort;
  let outgoingMessages: any[] = [];
  let handshakeComplete = false;

  const internalFlushMessages = () => {
    if (outgoingMessages.length === 0) {
      return;
    }
    const queuedMessages = [...outgoingMessages];
    outgoingMessages = [];
    messagePort.postMessage({
      type: BATCH_MESSAGE,
      messages: queuedMessages,
    });
  };

  const postMessage = (payload: any) => {
    outgoingMessages.push(payload);

    if (handshakeComplete) {
      internalFlushMessages();
    }
  };

  const internalSetPort = (port: MessagePort) => {
    messagePort = port;
  };

  const setHandshakeComplete = () => {
    internalFlushMessages();
    handshakeComplete = true;
  };

  return {
    postMessage,
    internalFlushMessages,
    internalSetPort,
    setHandshakeComplete,
  };
};
